import { bboxToCenter as x, computeBbox as b, distance as p, squaredDistance as H, isOverlapping as Y, bufferBboxByRatio as d } from "@allmaps/stdlib";
function $(e, t, o, i) {
  let r = Number.POSITIVE_INFINITY, n = e.at(-1);
  for (const l of e) {
    const c = Math.abs(
      Math.log2(l.scaleFactor) - (Math.log2(t + o) + i)
    );
    c < r && (r = c, n = l);
  }
  return n;
}
function q(e, t, o) {
  const i = C(e, t), r = y(i), n = N(r, t, o), l = x(b(e));
  return n.sort(
    (c, s) => F(c, l) - F(s, l)
  ), n;
}
function C(e, t) {
  return e.map((o) => [
    o[0] / t.originalWidth,
    o[1] / t.originalHeight
  ]);
}
function y(e) {
  const t = {};
  for (let o = 0; o < e.length; o++) {
    const i = [e[o], e[(o + 1) % e.length]];
    I(i).forEach(([n, l]) => {
      t[n] || (t[n] = [Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY]), l < t[n][0] && (t[n][0] = l), l > t[n][1] && (t[n][1] = l);
    });
  }
  return t;
}
function I([e, t]) {
  let o = Math.floor(e[0]), i = Math.floor(e[1]);
  const r = Math.floor(t[0]), n = Math.floor(t[1]), l = [[o, i]];
  if (o === r && i === n)
    return l;
  const c = Math.sign(t[0] - e[0]), s = Math.sign(t[1] - e[1]), h = Math.abs(e[0] - o - Math.max(0, c)), u = Math.abs(e[1] - i - Math.max(0, s)), a = Math.abs(e[0] - t[0]), f = Math.abs(e[1] - t[1]);
  let g = h / a, m = u / f;
  const A = 1 / a, R = 1 / f;
  for (; !(o === r && i === n); )
    g < m ? (g = g + A, o = o + c) : (m = m + R, i = i + s), l.push([o, i]);
  return l;
}
function N(e, t, o) {
  const i = [];
  for (const r in e) {
    const n = parseInt(r);
    if (n < 0 || n >= t.columns)
      break;
    const l = Math.max(e[n][0], 0), c = Math.min(e[n][1], t.rows - 1);
    for (let s = l; s <= c; s++)
      i.push({
        column: n,
        row: s,
        tileZoomLevel: t,
        imageSize: o
      });
  }
  return i;
}
function L(e, t, o, i) {
  let r = Math.floor(
    e.column * e.tileZoomLevel.scaleFactor / o
  );
  r = r >= 0 ? r : 0;
  const n = Math.ceil(
    (e.column + 1) * e.tileZoomLevel.scaleFactor / o
  );
  let l = Math.floor(
    e.row * e.tileZoomLevel.scaleFactor / o
  );
  l = l >= 0 ? l : 0;
  const c = Math.ceil(
    (e.row + 1) * e.tileZoomLevel.scaleFactor / o
  );
  return O(
    o,
    t,
    r,
    n,
    l,
    c,
    i
  );
}
function O(e, t, o, i, r, n, l = (c) => !0) {
  const c = t.tileZoomLevels.find(
    (u) => u.scaleFactor == e
  ), s = [t.width, t.height];
  if (!c)
    return [];
  o = o || 0, i = i || c.columns, r = r || 0, n = n || c.rows;
  const h = [];
  for (let u = o; u < i; u++)
    for (let a = r; a < n; a++) {
      const f = {
        column: u,
        row: a,
        tileZoomLevel: c,
        imageSize: s
      };
      l(f) && h.push(f);
    }
  return h;
}
function P(e, t) {
  return e.column == t.column && e.row == t.row && e.tileZoomLevel.scaleFactor == t.tileZoomLevel.scaleFactor;
}
function U(e, t) {
  return p(M(e), t);
}
function F(e, t) {
  return H(M(e), t);
}
function M(e) {
  const t = w(e);
  return [(t[2] - t[0]) / 2 + t[0], (t[3] - t[1]) / 2 + t[1]];
}
function T(e) {
  const t = e.column * e.tileZoomLevel.originalWidth, o = e.row * e.tileZoomLevel.originalHeight;
  return [t, o];
}
function k(e, t) {
  const o = [t.tileZoomLevel.width, t.tileZoomLevel.height];
  return e.map((i, r) => (i = Math.max(i, 0), i = Math.min(i, o[r] - 1), i));
}
function G(e, t, o = !0) {
  const i = T(t), r = [
    (e[0] - i[0]) / t.tileZoomLevel.scaleFactor,
    (e[1] - i[1]) / t.tileZoomLevel.scaleFactor
  ];
  if (!o || B(e, t))
    return r;
}
function B(e, t) {
  const o = T(t);
  return e[0] >= o[0] && e[0] <= o[0] + t.tileZoomLevel.originalWidth && e[1] >= o[1] && e[1] <= o[1] + t.tileZoomLevel.originalHeight;
}
function K(e, t) {
  return e[0] > 0 && e[0] <= t.imageSize[0] && e[1] > 0 && e[1] <= t.imageSize[1];
}
function w(e) {
  const t = T(e), o = Math.min(
    t[0] + e.tileZoomLevel.originalWidth,
    e.imageSize[0]
  ), i = Math.min(
    t[1] + e.tileZoomLevel.originalHeight,
    e.imageSize[1]
  );
  return [
    t[0],
    t[1],
    o,
    i
  ];
}
function X(e) {
  return e.tileZoomLevel.width * e.tileZoomLevel.height;
}
function z(e) {
  return e.tileZoomLevel.originalWidth * e.tileZoomLevel.originalHeight;
}
function E(e) {
  return e.map((t) => X(t)).reduce((t, o) => t + o, 0);
}
function j(e) {
  return e.map((t) => z(t)).reduce((t, o) => t + o, 0);
}
function J(e) {
  return e.rows * e.width * e.columns * e.height;
}
function Q(e) {
  return e.rows * e.originalWidth * e.columns * e.originalHeight;
}
function ee(e, t, o, i, r, n) {
  const l = [], c = Z(
    e,
    t,
    o,
    i,
    n
  );
  for (const s of c)
    s && l.push(s);
  if (l.length == 0) {
    const s = S(
      e,
      t,
      o,
      r,
      n
    );
    s && l.push(s);
  }
  return l;
}
function S(e, t, o, i, r) {
  const n = 2 ** (Math.log2(o) + 1);
  if (n > t.tileZoomLevels.map((c) => c.scaleFactor).reduce((c, s) => c + s, 0) - o || i == 0)
    return;
  const l = W(
    e,
    t,
    n,
    r
  );
  return l ?? S(
    e,
    t,
    n,
    i--,
    r
  );
}
function Z(e, t, o, i, r) {
  const n = 2 ** (Math.log2(o) - 1);
  if (n <= 0 || i == 0)
    return [];
  const l = v(
    e,
    t,
    n,
    r
  ), c = v(
    e,
    t,
    n,
    (s) => !0
  );
  return l.length == c.length ? l : [
    ...l,
    ...Z(
      e,
      t,
      n,
      i--,
      r
    )
  ];
}
function W(e, t, o, i) {
  const r = L(
    e,
    t,
    o,
    i
  );
  if (r.length != 0)
    return r[0];
}
function v(e, t, o, i) {
  return L(
    e,
    t,
    o,
    i
  );
}
function te(e) {
  return D(e.mapId, e.tileUrl);
}
function D(e, t) {
  return `${e}:${t}`;
}
function oe(e) {
  return V(
    e.tileZoomLevel.scaleFactor,
    e.row,
    e.column
  );
}
function V(e, t, o) {
  return `${e}:${t}:${o}`;
}
function ie(e, t) {
  const o = t.getIiifTile(
    e.tileZoomLevel,
    e.column,
    e.row
  );
  return t.getImageUrl(o);
}
function ne(e, t, o) {
  if (t.currentOverviewTileZoomLevel && e.tileZoomLevel.scaleFactor == t.currentOverviewTileZoomLevel.scaleFactor)
    return !1;
  if (t.currentResourceViewportRingBbox == null || t.currentTileZoomLevel == null)
    return !0;
  const i = Math.log2(e.tileZoomLevel.scaleFactor) - Math.log2(t.currentTileZoomLevel.scaleFactor);
  return i > o.maxHigherLog2ScaleFactorDiff || -i > o.maxLowerLog2ScaleFactorDiff || !Y(
    d(
      w(e),
      Math.max(0, i)
    ),
    t.currentResourceViewportRingBbox
  );
}
export {
  k as clipTilePointToTile,
  w as computeBboxTile,
  q as computeTilesCoveringRingAtTileZoomLevel,
  U as distanceTileToPoint,
  P as equalTileByRowColumnScaleFactor,
  te as fetchableTileKey,
  $ as getBestTileZoomLevelForScale,
  W as getTileAtHigherScaleFactor,
  z as getTileOriginalResolution,
  X as getTileResolution,
  Q as getTileZoomLevelOriginalResolution,
  J as getTileZoomLevelResolution,
  v as getTilesAtLowerScaleFactor,
  ee as getTilesAtOtherScaleFactors,
  O as getTilesAtScaleFactor,
  L as getTilesCoveringTileAtScaleFactor,
  j as getTilesOriginalResolution,
  E as getTilesResolution,
  D as keyFromMapIdTileUrl,
  V as keyFromScaleFactorRowColumn,
  S as recursivelyGetTilesAtHigherScaleFactor,
  Z as recursivelyGetTilesAtLowerScaleFactor,
  K as resourcePointInImage,
  B as resourcePointInTile,
  G as resourcePointToTilePoint,
  ne as shouldPruneTile,
  F as squaredDistanceTileToPoint,
  M as tileCenter,
  oe as tileKey,
  T as tilePosition,
  ie as tileUrl
};
//# sourceMappingURL=tiles.js.map
